import { Div } from "../../../../base/components/native/div"
import { Input } from "../../../../base/components/native/input"
import { checkTdStyle, checkTdInputStyle } from "./check.td.style"
import { RateTd } from "./rate-td"

export const CheckTd = (checked: boolean) => {

    const base = RateTd()
    base.cssClass(checkTdStyle)

    const check = Input('', 'checkbox')
    check.cssClass(checkTdInputStyle)
    // check.on('change', (e: Event, checked: boolean) => {
    //     console.log('checked:', e, checked)
    // })
    // check.on('click', (e: Event) => {
    //     console.log('clicked:', e)
    // })
    // if (checked) check.el.setAttribute('checked', 'true')
    // Math.random() > 0.5 && check.el.setAttribute('disabled', 'true')
    base.append(check)

    return Object.assign(base, {
        getValue: () => {
            return (check.el as HTMLInputElement).checked
        },
        enable: () => {
            (check.el as HTMLInputElement).disabled = false
        },
        check: () => {
            check.el.classList.add('checked');
            (check.el as HTMLInputElement).checked = true;
        },
        disable: () => {
            check.el.classList.remove('checked');
            (check.el as HTMLInputElement).checked = false;
            (check.el as HTMLInputElement).disabled = true;
        },
    })
}